module.exports = __webpack_public_path__ + "img/jimmy.f3926e24.svg";